/* eslint-disable prefer-const */
/* eslint-disable object-curly-newline */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { signInSuccess, signFailure } from './actions';

const states = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
];

export function* signIn({ payload }) {
  try {
    const { email, password } = payload;

    const response = yield call(api.post, 'sessions', {
      email,
      password,
    });

    const { token, user } = response.data;

    api.defaults.headers.Authorization = `Bearer ${token}`;

    yield put(signInSuccess(token, user));

    history.push('/conquer');
  } catch (err) {
    toast.error('Falha na autenticaçāo, verifique os seus dados.');
    yield put(signFailure());
  }
}

export function* signUp({ payload }) {
  try {
    let {
      firstName,
      lastName,
      email,
      birthday,
      city,
      state,
      level,
      english,
      password,
      // roles,
    } = payload;

    state = states[state];

    yield call(api.post, 'users', {
      first_name: firstName,
      last_name: lastName,
      email,
      birthday,
      city,
      state,
      level,
      english,
      password,
      // roles,
    });
    toast.success('Cadastro feito com sucesso.');
    history.push('/');
  } catch (err) {
    toast.error('Falha no cadastro, todos os campos sāo obrigatórios.');
    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;
  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token.token}`;
  }
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_UP_REQUEST', signUp),
  takeLatest('@auth/SIGN_OUT', signOut),
]);
